<script>
export default {
  name: 'IdenticalFormulationModal'
}
</script>

<script setup>
import { ref, computed, onMounted, watch, onUpdated} from 'vue';
import { tools } from '@functions/tools.js';
import IdenticalFormulationItem from './IdenticalFormulationItem.vue'
import axios from 'axios';
import { url } from '@/config/urls';
import router from '@/router/index.js';

// 外部定義メソッド
const { mapResponseError} = tools();

const props = defineProps({
  ordered: {
    type: Object,
    required: true
  },
  getIdenticalFormulationDrugListApiUrl: {
    type: String,
    default: url.api.identicalFormulationList
  },
  postIdenticalFormulationOrderApiUrl: {
    type: String,
    default: url.api.identicalFormulationOrder
  },
  loginUrl: {
    type: String,
    default: url.login
  },
  errorUrl: {
    type: String,
    default: url.error
  }
});

const emits = defineEmits(['showFlashMessage']);

// エラーメッセージ
const errorMessage = ref({
  description: ''
});

// 選択中の検索桁数（初期値: '9'）
const selectedSearchCodeType = ref('9');

// 同一成分
const identicalFormulationList = ref({});

// 再発注フラグ
const reorderFlg = ref(false);

// 確認画面状態
const confirmTemplate  = ref({
  isConfirm: false,
  identicalFormulationList: new Array(1),
  selectedSearchCode: ''
});

const itemTemplate  = ref({
  orderInputMap: new Map()
});

// 注文No
const orderNo = ref(0);

// 商品情報
const goodsInfoString = computed({
  get() {
    if (props.ordered.formalGoodsName2) {
      return `${props.ordered.makerName}\n${props.ordered.formalGoodsName1}\n${props.ordered.formalGoodsName2}`
    }else {
      return `${props.ordered.makerName}\n${props.ordered.formalGoodsName1}`
    }
  }
});

// 欠品情報
const shortageAmount = computed({
  get() {
    return `欠品数： ${props.ordered.shortageAmount ? props.ordered.shortageAmount.toLocaleString() : 0}個`
  }
});

// 同一成分検索パラメータ
const IdenticalFormulationCondition = computed({
  get() {
    return {
      searchCodeType: selectedSearchCodeType.value,
      janCode: props.ordered.janCode
    };
  }
});

// 選択済みの検索コードを取得
onUpdated(() => {
  for (let option of document.querySelectorAll('select#selectedSearchCodeType option')){
    if (option.selected){
      confirmTemplate.value.selectedSearchCode = option.textContent;
      break;
    }
  }
});

// 同一成分検索
const getIdenticalFormulationDrugList = () => {
  confirmTemplate.value.isConfirm = false;
  errorMessage.value.description = "";
  axios.get(props.getIdenticalFormulationDrugListApiUrl, { params: IdenticalFormulationCondition.value })
    .then((response) => {
      identicalFormulationList.value = response.data.response.identicalFormulationList;
      reorderFlg.value = response.data.response.reorderFlg;
    })
    .catch((error) => {
      switch(error?.response?.status) {
        case 400:
          // ユーザー依存で発生し得ないため500と同じ挙動
          sessionStorage.setItem('errorHeading', 'サーバーエラー。');
          sessionStorage.setItem('errorBody', 'サーバーで問題が発生しました。現在、サービス提供ができない可能性があります。しばらくしてから再度アクセスしてください。');
          router.replace(props.errorUrl);
          break;
        case 401:
          router.replace(props.loginUrl);
          break;
        case 404:
          identicalFormulationList.value = [];
          break;
        case 500:
          sessionStorage.setItem('errorHeading', 'サーバーエラー。');
          sessionStorage.setItem('errorBody', 'サーバーで問題が発生しました。現在、サービス提供ができない可能性があります。しばらくしてから再度アクセスしてください。');
          router.replace(props.errorUrl);
          break;
        default: break;
      }
    })
}

onMounted(() => {
  watch([() => props.ordered, selectedSearchCodeType], () => {
    if (props.ordered && selectedSearchCodeType) {
      const orderAmountList = document.querySelectorAll("td[data-label='発注数'] input");
      orderAmountList.forEach(function(orderAmount) {
        itemTemplate.value.orderInputMap.set(orderAmount.id, orderAmount.value);
        orderAmount.classList.remove('error');
      });

      getIdenticalFormulationDrugList();

    }
  });


  $('#modal1').on('hidden.bs.modal', function () {
    setTimeout(() => {
      // 発注数入力値リセット
      const orderAmountList = document.querySelectorAll("td[data-label='発注数'] input");
      orderAmountList.forEach(function(orderAmount) {
        orderAmount.value = "";
        orderAmount.classList.remove('error');
      });
      itemTemplate.value.orderInputMap = new Map();
      orderNo.value = 0;
      errorMessage.value.description = "";
      confirmTemplate.value.isConfirm = false;
      selectedSearchCodeType.value = '9';
      $('html').css('scroll-behavior', 'smooth');
    }, 10);
  })
})

// 確認ボタン押下
const onClickConfirmButton = () => {
  let isNanNumber = false;
  let isMultipleInput = false;
  let orders = [];
  let orderIndexes = [];
  let inputOrders = document.querySelectorAll('td[data-label="発注数"] input');
  errorMessage.value.description = '';
  inputOrders.forEach((inputOrder) => inputOrder.classList.remove('error'));
  // バリデーションチェック
  for (let i=0; i < inputOrders.length; i++) {
    let orderAmount = inputOrders[i].value;
    if ("" !== orderAmount && "0" !== orderAmount) {
      if (!orderAmount.includes("+") &&
          !orderAmount.includes(".") &&
          !isNaN(orderAmount) &&
          1 <= Number(orderAmount) &&
          999 >= Number(orderAmount)
      ) {
        orderNo.value = i;
        orders.push(Number(orderAmount));
        orderIndexes.push(i);
        confirmTemplate.value.identicalFormulationList[0] = identicalFormulationList.value[i];
      } else {
        isNanNumber = true;
        inputOrders[i].classList.add('error');
        break;
      }
    }
  }
  // 発注数に1～999の数字以外を入力した場合
  if (0 == orders.length || isNanNumber){
    errorMessage.value.description = '発注数は1～999の間で入力してください。';
    return false;
  }

  // 複数の商品に1以上の値が設定されていた場合
  if (1 < orders.length){
    orderIndexes.forEach((index) => inputOrders[index].classList.add('error'));
    errorMessage.value.description = '複数商品を同時に発注することはできません。';
    return false;
  }

  confirmTemplate.value.isConfirm = true;

  const orderAmountList = document.querySelectorAll("td[data-label='発注数'] input");
  itemTemplate.value.orderInputMap = new Map();
  orderAmountList.forEach(function(orderAmount) {
    itemTemplate.value.orderInputMap.set(orderAmount.id, orderAmount.value);
  });
  return false;
}

// 発注ボタン押下
const onClickOrderButton = () => {
  const param = {
    saleDetailId: props.ordered.orderId,
    orderJanCode: document.querySelector('td[data-label="商品コード"]').textContent,
    orderAmount:  document.querySelector('td[data-label="発注数"]').textContent
  };
  axios.post(props.postIdenticalFormulationOrderApiUrl, param)
    .then((response) => {
     confirmTemplate.value.isConfirm = false;
     // モーダルを閉じる
     document.querySelector('.btn-close').click();
     // フラッシュメッセージ 「発注しました」
     emits('showFlashMessage', 'order');
    })
    .catch((error) => {
      switch(error?.response?.status) {
        case 400:
          confirmTemplate.value.isConfirm = false;
          if (error.response.data.error instanceof Array) {
            errorMessage.value.description = mapResponseError(error.response, ['saleDetailId']);
          }
          break;
        case 401:
          location.href = props.loginUrl;
          break;
        case 403:
          reorderFlg.value = false;
          confirmTemplate.value.isConfirm = false;
          errorMessage.value.description = "お客様のアカウントでは現在再発注機能は利用できません。";
          break;
        case 500:
          sessionStorage.setItem('errorHeading', 'サーバーエラー。');
          sessionStorage.setItem('errorBody', 'サーバーで問題が発生しました。現在、サービス提供ができない可能性があります。しばらくしてから再度アクセスしてください。');
          location.href = props.errorUrl;
          break;
        default: break;
      }
    })
}

// 戻るボタン押下
const onClickBackButton = () => {
  confirmTemplate.value.isConfirm = false;
}
</script>

<template>
<div class="modal fade com_modal1" id="modal1" tabindex="-1" aria-labelledby="modal1Label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <div class="com_zstatus1">
          <span class="text-pre-wrap">{{ goodsInfoString }}</span>
          <span>{{ shortageAmount }}</span>
        </div>
        <h2 class="com_title1 com_mgb10">同一成分検索</h2>
        <template v-if="confirmTemplate.isConfirm">
          <p class="text-center">{{ confirmTemplate.selectedSearchCode }}</p>
        </template>
        <template v-else>
          <select id="selectedSearchCodeType" class="form-select com_form1 wd1 com_mg_a" v-model="selectedSearchCodeType">
            <option value="7">【7桁】一般名</option>
            <option value="8">【8桁】一般名＋剤型</option>
            <option value="9" selected>【9桁】一般名＋剤型+規格</option>
          </select>
        </template>
        <template v-if="reorderFlg">
          <div class="com_btn_group1 com_mgt15 com_mgb20">
            <button type="button" v-if="!confirmTemplate.isConfirm && identicalFormulationList.length != 0" class="btn com_btn5 cl1" @click="onClickConfirmButton">確認</button>
            <button type="button" v-if="confirmTemplate.isConfirm" class="btn com_btn5 cl1" @click="onClickOrderButton">発注</button>
            <button type="button" v-if="confirmTemplate.isConfirm" class="btn com_btn5" @click="onClickBackButton">戻る</button>
          </div>
  			</template>
        <template v-if="identicalFormulationList.length == 0">
          <p class="text-center com_mgb5">検索結果は0件です</p>
        </template>
        <template v-else>
          <template v-if="errorMessage.description != ''">
            <div class="text-center com_mgb5 com_validate_msg1 error">
              {{ errorMessage.description }}
            </div>
          </template>
          <template v-else-if="!confirmTemplate.isConfirm">
            <p class="text-center com_mgb5">同一成分一覧は以下の通りです<br>商品の詳細情報は添付文書をご確認ください</p>
          </template>
          <div class="com_table_wrap1">
            <table class="com_table1">
              <colgroup>
                <col style="width: 3.5em" />
                <col />
                <col style="width: 6em" />
                <col style="width: 14.5em" />
                <col span="3" />
                <col style="width: 11em" />
              </colgroup>
              <thead>
              <tr>
                <th>分類</th>
                <th>商品コード</th>
                <th>メーカー</th>
                <th>商品名</th>
                <th>単位薬価</th>
                <th>GE</th>
                <th>添付<br>文書</th>
                <th>商品情報</th>
                <th>在庫</th>
              <template v-if="reorderFlg">
                <th>発注数</th>
              </template>
              </tr>
              </thead>
              <tbody>
              <template v-if="confirmTemplate.isConfirm" v-for="(identicalFormulation, index) in confirmTemplate.identicalFormulationList">
                <IdenticalFormulationItem
                  :item="identicalFormulation"
                  :index="index"
                  :isConfirm="confirmTemplate.isConfirm"
                  :orderInputMap="itemTemplate.orderInputMap"
                  :reorderFlg="reorderFlg"
                ></IdenticalFormulationItem>
              </template>
              <template v-else v-for="(identicalFormulation, index) in identicalFormulationList">
                <IdenticalFormulationItem
                  :item="identicalFormulation"
                  :index="index"
                  :reorderFlg="reorderFlg"
                  :orderInputMap="itemTemplate.orderInputMap"
                ></IdenticalFormulationItem>
              </template>
              </tbody>
            </table>
          </div>
          <template v-if="reorderFlg">
            <div class="com_btn_group1 com_mgt15 com_reorder_btn_bottom1">
              <button type="button" v-if="!confirmTemplate.isConfirm" class="btn com_btn5 cl1" @click="onClickConfirmButton">確認</button>
              <button type="button" v-if="confirmTemplate.isConfirm" class="btn com_btn5 cl1" @click="onClickOrderButton">発注</button>
              <button type="button" v-if="confirmTemplate.isConfirm" class="btn com_btn5" @click="onClickBackButton">戻る</button>
            </div>
          </template>
        </template>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
    </div>
  </div>
</div>
</template>

<style scoped>
.text-pre-wrap {
  white-space: pre-wrap
}
</style>
